__turbopack_context__.v({
  "jetDetails": "jetDetails-module-scss-module__L4hYda__jetDetails",
  "jetDetailsContent": "jetDetails-module-scss-module__L4hYda__jetDetailsContent",
  "jetDetailsLine": "jetDetails-module-scss-module__L4hYda__jetDetailsLine",
  "jetDetailsLineItems": "jetDetails-module-scss-module__L4hYda__jetDetailsLineItems",
  "jetDetailsLineMaineTitle": "jetDetails-module-scss-module__L4hYda__jetDetailsLineMaineTitle",
  "jetDetailsLineTitle": "jetDetails-module-scss-module__L4hYda__jetDetailsLineTitle",
  "jetDetailsLineValue": "jetDetails-module-scss-module__L4hYda__jetDetailsLineValue",
  "jetDetailsTitle": "jetDetails-module-scss-module__L4hYda__jetDetailsTitle",
});
